export default function LibraryPage() {
    return (
        <div className="contentDiv">
            <h1>Library page</h1>
            <p>
                lorem ipsum
            </p>
        </div>
    );
}
